import { render, staticRenderFns } from "./PreviewChooserSettings.vue?vue&type=template&id=3acca7a9&"
import script from "./PreviewChooserSettings.vue?vue&type=script&lang=ts&"
export * from "./PreviewChooserSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewChooserSettings.vue?vue&type=style&index=0&id=3acca7a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports